import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { BaasLink, BaasLinkOptions } from '@lvflanders/bar-ng-ui';

@Component({
    template: '<baas-link [item]="link" [zeroWhiteLineIfHidden]="true"></baas-link>',
    selector: 'bar-link-cell-renderer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasLink]
})
/** BAR ag-grid cell renderer to render a BAR (hyper)link. */
export class BaasLinkCellRenderer implements ICellRendererAngularComp {
    params: ICellRendererParams;
    link: BaasLinkOptions;

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        const linkAttr = (this.params as any).link;
        if (linkAttr != null) {
            let link: BaasLinkOptions;
            // function in case computed (which is the default)
            if (linkAttr instanceof Function) {
                link = linkAttr(this.params.data);
            } else {
                link = linkAttr;
            }
            if (link.content == null && this.params.colDef.field != null && this.params.colDef.field.length > 0) {
                // if the content is left empty by default we take the field
                link.content = this.params.data[this.params.colDef.field];
            }

            this.link = link;
        }
    }
}
